// Wait for a specified amount of time, then return a promise.

/**
 * Wait for a specified amount of time, then return a promise.
 * 
 * @param ms The amount of milliseconds you want to wait.
 * @returns Promise.
 */
function wait( ms: number ): Promise<void>
{
	return new Promise<void>(
		( resolve: () => void ) =>
			setTimeout(
				resolve,
				ms,
			),
	);
}

/**
 * Module
 */
export {
	wait as default,
};



// WEBPACK FOOTER //
// ./utils/animation/wait.ts